import {
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';
import { FaWhatsapp, FaTwitter, FaLinkedinIn, FaFacebookF, FaTelegram } from 'react-icons/fa';

import { ButtonsContainer } from './styles';

type ShareButtonsProps = {
  slug: string;
};

export default function ShareButtons({ slug }: ShareButtonsProps) {
  const url = `https://kenzie.com.br/blog/${slug}`;
  return (
    <ButtonsContainer>
      <LinkedinShareButton
        url={url}
        style={{
          fontSize: '2.5rem',
          color: '#0e76a8',
          marginTop: '0.5rem',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <FaLinkedinIn style={{ fontSize: '100%' }} />
      </LinkedinShareButton>
      <WhatsappShareButton
        url={url}
        style={{
          fontSize: '2.5rem',
          color: '#25d366',
          marginTop: '0.5rem',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <FaWhatsapp style={{ fontSize: '100%' }} />
      </WhatsappShareButton>

      <FacebookShareButton
        url={url}
        style={{
          fontSize: '2.5rem',
          color: '#1877f2',
          marginTop: '0.5rem',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <FaFacebookF style={{ fontSize: '100%' }} />
      </FacebookShareButton>
      <TwitterShareButton
        url={url}
        style={{
          fontSize: '2.5rem',
          color: '#00acee',
          marginTop: '0.5rem',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <FaTwitter style={{ fontSize: '100%' }} />
      </TwitterShareButton>
      <TelegramShareButton
        url={url}
        style={{
          fontSize: '2.5rem',
          color: '#34A2E0',
          marginTop: '0.5rem',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <FaTelegram style={{ fontSize: '100%' }} />
      </TelegramShareButton>
    </ButtonsContainer>
  );
}
